import type { PartialBlock } from '@blocknote/core';

import type { PartialBlockWithTypedContent } from './block-content-types';

/**
 * Replaces custom blocks that are unsafe during read-only initialization with
 * neutral paragraphs before the BlockNote document tree is created.
 */
export function stripReadOnlyProblemBlocks(
  blocks: PartialBlock[],
): PartialBlock[] {
  return blocks.flatMap((block) => {
    const typedBlock = block as PartialBlockWithTypedContent;

    if (typedBlock.type === 'horizontalRule') {
      // The custom horizontal rule renderer can crash in read-only BlockNote
      // initialization ("Cannot find node position" from the React node view's
      // getPos before ProseMirror registers it), so read-only documents mount
      // with a neutral paragraph instead. Visible read-mode dividers are
      // rendered outside BlockNote via `buildReadModeSegments`, so this does
      // not hide dividers in the main read-mode note view.
      return [
        {
          id: typedBlock.id,
          type: 'paragraph',
          props: {},
          content: [],
          children: [],
        } as PartialBlock,
      ];
    }

    return [
      {
        ...typedBlock,
        children: Array.isArray(typedBlock.children)
          ? stripReadOnlyProblemBlocks(typedBlock.children)
          : typedBlock.children,
      } as PartialBlock,
    ];
  });
}
